module.exports = __webpack_public_path__ + "img/bu1.53a72658.png";